import { StoreSelector } from "@faire/web--source/ui/hooks/ContextStore";

import {
  SelfServeNodeLevel,
  SelfServeContext,
  SelfServeNodeLevels,
  SelfServeNodeLevelWithExtra,
} from "../types";

import { buildNodeLevelPropName } from "./buildNodeLevelPropName";
import { clearCurrentNodeLevelAndAboveFromLocalStorage } from "./localStorage";

type NodeResetParams = {
  level: SelfServeNodeLevelWithExtra;
  setSelfServeContextStore: (selector: StoreSelector<SelfServeContext>) => void;
};

export const resetCurrentNodeLevelStateAndAbove = ({
  level,
  setSelfServeContextStore,
}: NodeResetParams) => {
  let resetNodes = {} as SelfServeContext;
  for (
    let levelAbove = level as SelfServeNodeLevel;
    levelAbove <= SelfServeNodeLevels.length;
    levelAbove++
  ) {
    const nodeLevelProp = buildNodeLevelPropName(levelAbove);
    resetNodes = { ...resetNodes, [nodeLevelProp]: undefined };
  }
  setSelfServeContextStore(resetNodes);
  clearCurrentNodeLevelAndAboveFromLocalStorage(level);
};
